import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import { Bar } from "react-chartjs-2"
import Title from "../general/title"
import times from "helpers/times"
import moment from "moment"
import general from "helpers/general"
import colorArray from "helpers/colorArray"
import monoColorArray from "helpers/monoColorArray"
import ImageExport from "components/ImageExport"
import FullTable from "components/FullTable"
import numeral from "numeral"
import helpers from "helpers/helpers"

class Completes extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filters: {},
			times: times(),
			model: {
				gross_sales_contract: 0,
				average_home_price: 0,
				average_square_feet: 0,
				average_ppsqft: 0,
				average_lot_price: 0,
				percent_lot_home: 0,
				total: 0,
				totalHomePrice: 0,
				totalSqft: 0,
				totalLotPrice: 0,
			},
			columns: [
				{
					Header: "Year",
					accessor: "year",
					filterMethod: (f, r) => helpers.tableText(f, r, "year"),
				},
				{
					Header: "Month",
					accessor: "monthNumber",
					Cell: (v) => {
						let mo = moment(v.value, "M").format("MMM")
						return mo.toUpperCase()
					},
					filterMethod: (f, r) => helpers.tableText(f, r, "month"),
				},
				{
					Header: "Completes",
					accessor: "completes",
					filterMethod: (f, r) => helpers.tableText(f, r, "completes"),
					Footer: (props) => helpers.tableTotals(props, "completes", "0,0"),
				},
			],
			statusColumns: [
				{
					Header: "Community",
					accessor: "Community",
					filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
				},
				{
					Header: "Lot",
					accessor: "Lot",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot"),
				},
				{
					Header: "Block",
					accessor: "Block",
					filterMethod: (f, r) => helpers.tableText(f, r, "Block"),
				},
				{
					Header: "Section",
					accessor: "Section",
					filterMethod: (f, r) => helpers.tableText(f, r, "Section"),
				},
				{
					Header: "Address",
					accessor: "Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "Address"),
				},
				{
					Header: "Complete Date",
					accessor: "Complete Date",
					filterMethod: (f, r) => helpers.tableText(f, r, "Complete Date"),
				},
				{
					Header: "Floorplan",
					accessor: "Floorplan",
					filterMethod: (f, r) => helpers.tableText(f, r, "Floorplan"),
				},
				{
					Header: "Elevation",
					accessor: "Elevation",
					filterMethod: (f, r) => helpers.tableText(f, r, "Elevation"),
				},
			],
			detailedCompletes: [
				{
					Header: "Builder",
					accessor: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
				},
				{
					Header: "Address",
					accessor: "Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "Address"),
				},
				{
					Header: "Start Date",
					accessor: "Start Date",
					Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				},
				{
					Header: "Complete Date",
					accessor: "Complete Date",
					Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				},
				{
					Header: "Days To Complete",
					accessor: "daysToComplete",
					filterMethod: (f, r) => helpers.tableText(f, r, "daysToComplete"),
					Footer: (props) => helpers.tableAverages(props, "daysToComplete", "0,0"),
				},
				{
					Header: "Sq Ft",
					accessor: "sqft",
					filterMethod: (f, r) => helpers.tableText(f, r, "sqft"),
				},
				{
					Header: "Floorplan",
					accessor: "Floorplan",
					filterMethod: (f, r) => helpers.tableText(f, r, "Floorplan"),
				},
				{
					Header: "Buyer Status",
					accessor: "status",
					filterMethod: (f, r) => helpers.tableText(f, r, "status"),
				},
			],
			timeToComplete: [
				{
					Header: "Builder",
					accessor: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
				},
				{
					Header: "Lot Type",
					accessor: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
				},
				{
					Header: "Average Days To Complete",
					accessor: "Average Days To Complete",
					Cell: (props) => numeral(props.value).format("0,0"),
					Footer: (props) => helpers.tableAverages(props, "Average Days To Complete", "0.00"),
				},
			],
			statusSorted: [],
			ytd: [],
			monthly: [],
		}
	}

	buildData = () => {
		let store = {}
		let all = []
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (
				v.complete_date < this.props.currentDates.startStamp ||
				v.complete_date > this.props.currentDates.endStamp
			) {
				return
			}
			all.push(v)
			let year = moment.unix(v.complete_date).format("YYYY")
			let month = moment.unix(v.complete_date).format("MMM").toUpperCase()
			let path = `${year}.${month}`
			if (!_.has(store, path)) {
				_.set(store, path, 0)
			}
			store[year][month]++
		})

		let byMonth = {}
		_.forEach(store, (row, year) => {
			_.forEach(general.monthsArrayAbbrev, (mon) => {
				_.set(byMonth, `${year}.${mon}`, row[mon])
			})
		})
		let c = _.cloneDeep(byMonth)
		let ytd = {}
		let ytdCumulative = {}
		_.forEach(c, (row, year) => {
			let count = 0
			_.forEach(row, (val, month) => {
				if (!val) {
					val = 0
				}
				count += val
				_.set(ytdCumulative, `${year}.${month}`, count)
			})
			count = 0
			_.forEach(row, (val, month) => {
				_.set(ytd, `${year}.${month}`, val)
			})
		})
		return { byMonth, ytd, ytdCumulative, all }
	}

	completesChart = () => {
		let data = this.buildData()
		let labels = []
		if (!_.isEmpty(data.byMonth)) {
			labels = Object.keys(data.byMonth[Object.keys(data.byMonth)[0]])
		}
		let datasets = []
		let i = 0
		let monthNum = moment.unix(this.props.currentDates.endStamp).month()
		_.forEach(data.ytdCumulative, (row, year) => {
			_.forEach(row, (val, month) => {
				let rowMonth = moment(month, "MMM").month()
				if (rowMonth > monthNum) {
					delete data.ytdCumulative[year][month]
				}
			})
		})
		_.forEach(data.ytdCumulative, (row, year) => {
			datasets.push({
				label: `YTD - ${year}`,
				type: "line",
				data: Object.values(row),
				backgroundColor: monoColorArray[i],
				borderColor: monoColorArray[i],
				yAxisID: "ytd",
				fill: false,
			})
			i++
		})
		i = 0
		_.forEach(data.byMonth, (row, year) => {
			datasets.push({
				label: `By Month - ${year}`,
				type: "bar",
				data: Object.values(row),
				backgroundColor: colorArray[i],
				yAxisID: "byMonth",
			})
			i++
		})

		const barData = {
			labels: labels,
			datasets: datasets,
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			plugins: {
				datalabels: { display: false },
			},
			scales: {
				yAxes: [
					{
						id: "ytd",
						type: "linear",
						position: "right",
						scaleLabel: {
							display: true,
							labelString: "YTD",
						},
					},
					{
						id: "byMonth",
						type: "linear",
						position: "left",
						scaleLabel: {
							display: true,
							labelString: "By Month",
						},
					},
				],
			},
		}

		return <Bar data={barData} options={opts} />
	}

	monthTable = () => {
		let data = this.buildData()
		let ret = []

		_.forEach(data.byMonth, (row, year) => {
			_.forEach(row, (v, month) => {
				let monthNumber = parseInt(moment(month, "MMM").format("M"))
				ret.push({
					year,
					month,
					monthNumber,
					completes: v,
				})
			})
		})
		return ret
	}

	detailedTable = () => {
		let data = this.buildData()
		let ret = []
		_.forEach(data.all, (v, year) => {
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let fp = _.find(this.props.payload.public.floorplans, { id: v.floorplan })
			ret.push({
				Builder: builder ? builder.name : "",
				Address: v.address,
				"Complete Date": v.complete_date,
				"Start Date": v.start_date,
				daysToComplete: v.complete_date && v.start_date ? moment.unix(v.complete_date).diff(moment.unix(v.start_date), "days") : 0,
				Floorplan: fp ? fp.name : "",
				status: v.lot_status || "Available",
				sqft: v.sqft ? numeral(v.sqft).format("0,0") : "",
			})
		})

		return ret
	}

	buildStatusTable = () => {
		let ret = []
		_.forEach(this.props.payload.exec.lots, (v) => {
			let fp = _.find(this.props.payload.public.floorplans, { id: v.floorplan })
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			let f = {
				Lot: v.lot,
				Block: v.block,
				Section: v.section_name,
				Community: property ? property.name : "",
				Address: v.address,
				"Complete Date": v.complete_date ? moment.unix(v.complete_date).format("MM/DD/YY") : "",
				Floorplan: fp ? fp.name : "",
				Elevation: v.elevation,
			}
			ret.push(f)
		})
		return ret
	}

	timeToComplete = () => {
		let ret = []
		let store = {}
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (!v.start_date || !v.complete_date) return
			if (v.start_date < this.props.currentDates.startStamp || v.start_date > this.props.currentDates.endStamp) {
				return
			}
			let start = moment.unix(v.start_date)
			let end = moment.unix(v.complete_date)
			let diff = end.diff(start, "days")
			if (diff < 50) return // This is weeding out bad data.
			// The START has to be between the time ranges.
			let model = {
				daysDiff: 0,
				gross: 0,
			}
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (!builder || !type) {
				console.error(`Cannot find builder or lot type for ${v.id}`)
				return
			}
			builder.name = builder.name.replace(/[^\w- ]+/g, "")
			let path = `${builder.name}.${type.name}`
			if (!_.has(store, path)) {
				_.setWith(store, path, model, Object)
			}
			
			store[builder.name][type.name].gross++
			store[builder.name][type.name].daysDiff += diff
		})

		_.forEach(store, (v1, builder) => {
			_.forEach(v1, (v2, type) => {
				ret.push({
					Builder: builder,
					"Lot Type": type,
					gross: v2.gross,
					"Average Days To Complete": v2.daysDiff / v2.gross,
					totalPrice: v2.daysDiff,
				})
			})
		})
		return ret
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Completes" />
						<div className="content">
							<div>
								<ImageExport name="Completes" />
								{this.completesChart()}
							</div>
							<h3>Monthly Completes</h3>
							<FullTable
								data={this.monthTable()}
								columns={this.state.columns}
								name="completes__months"
								title="Completes Months"
								pageSize={12}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<h3>Detailed List</h3>
							<FullTable
								data={this.detailedTable()}
								columns={this.state.detailedCompletes}
								name="completes__detailed"
								title="Completes"
								pageSize={20}
							/>
							<h3>Time To Complete</h3>
							<p className="mid">
								For optimal results, please use an extended date range. Table represents lots started
								between the time range.
							</p>
							<FullTable
								data={this.timeToComplete()}
								columns={this.state.timeToComplete}
								name="completes__timeToComplete"
								title="Time To Complete"
								pageSize={20}
								defaultSorted={[
									{
										id: "Average Days To Complete",
										desc: true,
									},
								]}
							/>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Completes)
